import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const BrowserEventHandler = ({
  onBeforeUnload = new Function(),
  onUnload = new Function(),
}) => {
  const isRecording = useSelector(
    (state) => state?.recordingStatus?.isRecording
  );
  const progress= useSelector(state=>state?.isLoading?.progress)
  useEffect(() => {
    if (isRecording||progress) {
      const handleBeforeUnload = (event) => {
        if (typeof onBeforeUnload === "function") {
          const confirmationMessage = onBeforeUnload();
          if (confirmationMessage) {
            event.preventDefault();
            event.returnValue = confirmationMessage;
          }
        }
      };

      const handleUnload = () => {
        if (typeof onUnload === "function") {
          onUnload();
        }
      };

      const handleNavigation = (event) => {
        const confirmationMessage = "Are you sure you want to leave this page?";
        if (typeof onBeforeUnload === "function") {
          const customConfirmationMessage = onBeforeUnload();
          if (customConfirmationMessage) {
            if (!window.confirm(customConfirmationMessage)) {
              event.preventDefault();
            }
          } else {
            if (!window.confirm(confirmationMessage)) {
              event.preventDefault();
            }
          }
        } else {
          if (!window.confirm(confirmationMessage)) {
            event.preventDefault();
          }
        }
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      window.addEventListener("unload", handleUnload);
      window.addEventListener("beforeunload", handleNavigation);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        window.removeEventListener("unload", handleUnload);
        window.removeEventListener("beforeunload", handleNavigation);
      };
    }
  }, [onBeforeUnload, onUnload, isRecording,progress]);

  return null;
};

export default BrowserEventHandler;
